import {NavigationGuardNext, RouteLocationNormalizedGeneric, RouteRecordRaw, RouterView} from "vue-router";
import HeaderView from "@/views/share/HeaderView.vue";
import BranchSideView from "@/views/brand/branch/BranchSideView.vue";
import {UserAgent} from "@/model/user_agent";
import {message} from "ant-design-vue";

export default <Array<RouteRecordRaw>>[
    {
        path: ':branch_id',
        meta: {auth: true},
        components: {
            default: RouterView,
            header: HeaderView,
            side: BranchSideView,
        },
        children: [
            {
                path: '',
                meta: {auth: true},
                beforeEnter: guide,
                component: () => import(/* webpackChunkName: "branch_overview" */  './BranchOverView.vue'),
            },
            {
                path: 'customers',
                meta: {auth: true},
                beforeEnter: guide,
                component: () => import(/* webpackChunkName: "branch_customers" */  './BranchCustomers.vue'),
            }
        ]
    }
]

function guide(to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric, next: NavigationGuardNext) {
    (to.meta.agent as UserAgent).meta.brands.forEach(b => {
        if (b.brand_id == to.params.brand_id) to.meta.brand = b
        b.branches.forEach(b => {
            if (b.branch_id == to.params.branch_id) to.meta.branch = b
        })
    })
    if (!to.meta.brand) {
        message.error('查无此品牌').then()
        next('/')
    } else if (!to.meta.branch) {
        message.error('查无此分支').then()
        next('/')
    } else next()
}